<template>
  <div :class="['topTis', pList.length === 1 ? 'tis-circle' : '', type]">
    <img
      v-if="pList.length === 1"
      src="@/assets/images/new_icon_waring_yellow.png"
      style="width: 14px; height: 14px; color: #ffffff"
    />
    <img
      v-else
      src="@/assets/images/new_icon_waring_red.png"
      style="width: 14px; height: 14px; color: #ffffff"
    />
    <div class="desc" style="margin-left: 2px" :style="{ color: pColor }">
      <p
        v-for="(item, index) in pList"
        :key="index"
        :style="{ color: item.Color }"
      >
        {{ item.text }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String | Array,
      default: [],
    },
    pColor: {
      type: String,
      default: "#333333",
    },
    type: {
      type: String,
      default: "warning",
    },
  },

  computed: {
    pList() {
      // console.log(typeof this.text);
      return typeof this.text === "string" ? [{ text: this.text }] : this.text;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 温馨提示表格 */
.topTis {
  // margin: 20px 28px 0 28px;
  // display: flex;
  // align-items: baseline;
  display: flex;
  justify-content: flex-start;
  align-items: start;
  line-height: 21px;
  position: relative;
  color: #333333;
  font-size: 14px;
  background: #fffaee;
  opacity: 1;
  padding: 12px;

  .desc {
    // display: flex;
    // line-height: 20px;
  }
  p {
    margin: 0px;
    // line-height: 20px;
    // width: 700px;
  }
  img {
    margin-top: 3px;
  }
}

.tis-circle {
  border-radius: 14px 14px 14px 14px;
  align-items: center;
  padding: 7px 12px;
  line-height: 14px;
  img {
    margin-top: 0px;
  }
}

/*类型 */
.info {
  background: #fafafa;
}
</style>
